// -------------------------------
// Unique Features
// -------------------------------

(function () {
  const root = document.querySelector('[data-unique-features]');
  if (!root) return;

  const modal = root.querySelector('[data-feature-modal]');
  const titleEl = modal?.querySelector('.feature-modal__title');
  const textEl = modal?.querySelector('.feature-modal__text');
  const iconContainer = modal?.querySelector('.feature-modal__icon');

  if (!modal || !titleEl || !textEl) return;

  let lastFocus = null;
  const ANIM_MS = 180; // passend zu CSS (170ms + kleinen Puffer)

  // -------------------------------
  // Modal
  // -------------------------------
  function openModal(title, text, item) {
    lastFocus = document.activeElement;

    titleEl.textContent = title || '';
    textEl.textContent = text || '';

    // Use large icon URL if available, otherwise clone small one
    if (iconContainer) {
      iconContainer.innerHTML = '';
      const iconUrl = item?.getAttribute('data-feature-icon');

      if (iconUrl) {
        const img = document.createElement('img');
        img.src = iconUrl;
        img.alt = '';
        iconContainer.appendChild(img);
      } else {
        const iconImg = item?.querySelector('img');
        if (iconImg) {
          const clone = iconImg.cloneNode(true);
          clone.removeAttribute('width');
          clone.removeAttribute('height');
          iconContainer.appendChild(clone);
        }
      }
    }

    // Show + animate
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    // Force reflow so transition always triggers
    void modal.offsetWidth;

    modal.classList.add('is-open');

    const closeBtn = modal.querySelector('.feature-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    setTimeout(() => {
      modal.hidden = true;
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }, ANIM_MS);
  }

  // -------------------------------
  // Focus Trap (Accessibility)
  // -------------------------------
  function trapFocus(e) {
    if (modal.hidden || e.key !== 'Tab') return;

    const focusable = modal.querySelectorAll(
      'button, [href], [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // -------------------------------
  // Event Listeners
  // -------------------------------
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-feature-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    const trigger =
      e.target.closest('.logolist--image') ||
      e.target.closest('.logolist--feature-subheading') ||
      e.target.closest('[data-feature-trigger]');

    if (trigger) {
      const item = trigger.closest('[data-feature-trigger]');
      if (!item) return;

      e.preventDefault();
      openModal(
        item.getAttribute('data-feature-title'),
        item.getAttribute('data-feature-text'),
        item
      );
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!modal.hidden && e.key === 'Escape') closeModal();
  });

  document.addEventListener('keydown', trapFocus);

  // -------------------------------
  // Subtitle truncation: 3 lines + "…➚"
  // OPTIMIZED: Fewer DOM reflows
  // -------------------------------
  const items = Array.from(root.querySelectorAll('[data-feature-trigger]'));

  function truncateToLines(el, fullText, lines) {
    if (!fullText) return;

    // Get line height once
    const style = getComputedStyle(el);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.4;
    const maxHeight = Math.ceil(lineHeight * lines);

    // First check: does it even need truncation?
    el.textContent = fullText;
    if (el.scrollHeight <= maxHeight + 1) return;

    // Binary search with minimal DOM writes
    let lo = 0;
    let hi = fullText.length;
    let best = 0;

    while (lo <= hi) {
      const mid = (lo + hi) >> 1;
      el.textContent = fullText.slice(0, mid) + '… mehr ❯';

      if (el.scrollHeight <= maxHeight + 1) {
        best = mid;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }

    // Final render with proper markup
    el.textContent = '';
    el.appendChild(document.createTextNode(fullText.slice(0, best).trimEnd() + '…'));

    const arrow = document.createElement('span');
    arrow.className = 'logolist--feature-subtitle-arrow';
    arrow.textContent = ' mehr ❯';
    el.appendChild(arrow);
  }

  function applyAllTruncations() {
    items.forEach((item) => {
      const el = item.querySelector('.logolist--feature-subheading-text');
      if (!el) return;

      // Store original text once
      if (!el.dataset.fullText) {
        el.dataset.fullText = (el.textContent || '').trim();
      }

      truncateToLines(el, el.dataset.fullText, 3);
    });
  }

  // -------------------------------
  // Resize Handler (optimized)
  // -------------------------------
  if ('ResizeObserver' in window) {
    let resizeTimer = null;
    const ro = new ResizeObserver(() => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyAllTruncations, 100);
    });
    ro.observe(root);
  } else {
    // Fallback for old browsers
    let t = null;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(applyAllTruncations, 120);
    });
  }

  applyAllTruncations();

  // -------------------------------
  // Preload large modal icons
  // -------------------------------
  function preloadModalIcons() {
    items.forEach((item) => {
      const iconUrl = item.getAttribute('data-feature-icon');
      if (iconUrl) {
        const img = new Image();
        img.src = iconUrl;
      }
    });
  }

  // Preload after page is idle (non-blocking)
  if ('requestIdleCallback' in window) {
    requestIdleCallback(preloadModalIcons, { timeout: 2000 });
  } else {
    setTimeout(preloadModalIcons, 500);
  }
})();